var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnFolder2X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1. Icon/folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.026 7.626C17.494 7.094 16.78 6.8 16.038 6.8H8.8C7.26 6.8 6.014 8.06 6.014 9.6L6 26.4C6 27.94 7.26 29.2 8.8 29.2H31.2C32.74 29.2 34 27.94 34 26.4V12.4C34 10.86 32.74 9.6 31.2 9.6H20L18.026 7.626Z",
    fill: "#8B95A1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFolder2X);
export default __webpack_public_path__ + "static/media/icn-folder@2x.60af40ce.svg";
export { ForwardRef as ReactComponent };